module.exports = __webpack_public_path__ + "img/none.2d389c66.png";